import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import Lesmerpanel from "./../";
export const _frontmatter = {
  "ingress": "Lesmerpanel er en komponent som lar deg ekspandere og kollapse innhold. Passer for lengre tekster og infopanel der ikke alt innhold er like relevant. Komponenten bruker npm-pakken <a href=\"https://www.npmjs.com/package/react-collapse\">React-collapse</a> og extender props fra den."
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Example = makeShortcode("Example");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <nav {...{
      "className": "table-of-contents"
    }}><ol parentName="nav" {...{
        "className": "toc-level toc-level-1"
      }}><li parentName="ol" {...{
          "className": "toc-item toc-item-h2"
        }}><a parentName="li" {...{
            "className": "toc-link toc-link-h2",
            "href": "#normal"
          }}>{`Normal`}</a></li></ol></nav>
    <h2 {...{
      "id": "normal"
    }}>{`Normal`}</h2>
    <Example mdxType="Example">
  <Lesmerpanel intro={<span>
        Introduksjonstekst her som <a href="#">kan være HTML</a>
      </span>} border mdxType="Lesmerpanel">
    <div>
      <p style={{
            marginTop: 0
          }}>
        Du bestemmer selv om du vil bruke sykmeldingen eller avbryte den. Du kan
        også jobbe i kombinasjon med sykmelding. Det kommer an på hva sykdommen
        din tillater og hva det er praktisk mulig å få til på arbeidsplassen.
      </p>
      <p>
        Greit å vite: Arbeidsgiveren har plikt til å legge til rette for at du
        kan jobbe helt eller delvis selv om du er syk.
      </p>
    </div>
  </Lesmerpanel>
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Lesmerpanel
  intro={
    <span>
      Introduksjonstekst her som <a href="#">kan være HTML</a>
    </span>
  }
  border
>
  <div>
    <p style={{ marginTop: 0 }}>
      Du bestemmer selv om du vil bruke sykmeldingen eller avbryte den. Du kan
      også jobbe i kombinasjon med sykmelding. Det kommer an på hva sykdommen
      din tillater og hva det er praktisk mulig å få til på arbeidsplassen.
    </p>
    <p>
      Greit å vite: Arbeidsgiveren har plikt til å legge til rette for at du kan
      jobbe helt eller delvis selv om du er syk.
    </p>
  </div>
</Lesmerpanel>
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      